<script>
// 新建客户
import uploadAvatar from "@/views/widgets/upload-files/upload-avatar.vue";
import {useVuelidate} from "@vuelidate/core";
import {required, email} from "@vuelidate/validators";
import {alertError} from "@/helpers/swal";
import {
  patchUserAccount,
  getPartnerRoles,
  getPermissionTree,
  getUploadFileDetail,
  getUploadFileSign, serviceAreaProvince,
  postUpdateFile,
  roleList
} from "@/service";
import { CUSTOMER_INDUSTRY_LIST, CUSTOME_ATTR_LIST, COMPANY_SIZE,LEVEL_ATTR_LIST } from "@/config/common";
import SwiperTool from "@/components/swiperTool.vue";
import DropZone from "@/components/widgets/dropZone.vue";
import {imageCompress} from "@/utils/common";
import Swal from "sweetalert2";
import axios from "axios";
import { v4 as uuidv4 } from "uuid";

// import datePickr from "@/views/widgets/date-pickr.vue";
// import LocationSelect from "@/views/widgets/location-select.vue";
import i18n from "@/i18n";

export default {
  setup: () => ({ v$: useVuelidate() }),
  emits:["refresh"],
  props: {
    title: {
      type: String,
      default:  i18n.global.t("编辑账号"),

    },
    type: {
      type: String,
      default: 'user', // user-普通用户 organization-企业用户
    },
    editItem:{
      type: Object,
      default: ()=>{
        return {
          id:"",
          username: "",
          role_id: "",
          first_name:"",
          last_name: "",
          tel: "",
          email:"",
          tags: [],
          qualification: [],
          service_area: [],
          province_id: []
        }
      },
    }
  },
  data () {
    return {
      provinceList: [],
      roleType: "",
      roleList: [],
      roleListLoading: false,

      options: [
        {
          value: '重庆',
          label: '重庆',
          children: [
            {
              value: '张三',
              label: '张三',
            },
            {
              value: '李四',
              label: '李四',
            },
          ],
        },

      ],
      showfiles: [],
      showModal: false,
      logo: 0,

      INDUSTRY: CUSTOMER_INDUSTRY_LIST,
      CUSTOME_ATTR_LIST,
      COMPANY_SIZE,
      LEVEL_ATTR_LIST
    }
  },
  validations: {
    form: {
      username: { required },
      email:{ email,required },
      province_id: { required },
      first_name: { required },
      last_name: { required },
      tel: { required }
    }
  },
  mounted() {
    this.getRoleList();
    this.getProvince()
  },
  watch:{
    editItem: {
      immediate: true,
      deep: true,
      handler(val) {
       this.form = val
      }
    }

  },
  computed:{
    form(){
      return this.editItem
    }
  },
  methods: {
    provinceText(id, arr) {
      let str = ''
      arr && arr.map(item => {
        if (item.id == id) {
          str = item.label
        }
      })
      return str
    },
    roleChange(e){
      getPermissionTree(e).then(res=>{
        if ((res.payload.role_permissions + '').includes('auditing.role.sale')) {
          this.roleType = "sale"

        }
        else if ((res.payload.role_permissions + '').includes('auditing.role.technical')) {
          this.roleType = "technical"

        }else{
          this.roleType = "other"

        }
      })
    },
    filterNodeMethod(value, data) {
      if (!value) return true;
      return data.name.includes(value);
    },
    clearSelect() {
      this.formattedValue = null;
    },
    getRoleList() {
      this.roleListLoading = true;
      if (this.type === 'user') {
        roleList().then(res => {
          this.roleListLoading = false;
          this.roleList = res.payload;
        });
      } else {
        getPartnerRoles(this.belong_type).then(res => {
          this.roleListLoading = false;
          this.roleList = res.payload;
        });
      }
    },
    provinceChange(e) {
      this.form.service_area = []
      e.map(a => {
        let is_default = false
        let find = this.provinceList.filter((item) => {
          if (item.id == a && item.is_default) {
            is_default=true
            if(item.full_name!==(this.form.first_name+this.form.last_name)){
              is_default=false
              return item
            }
          }
        })
        let has_default = false
        if (find && find.length > 0)has_default = true;
        this.form.service_area.push({
          province_id: a,
          is_default: is_default,
          has_default: has_default
        })
      })
      let map = new Map()
      this.form.service_area = this.form.service_area.filter((item) => !map.has(item.province_id.toString()) && map.set(item.province_id.toString()))
    },
    checkFile(file) {
      let name = /^device\//.test(file.name)
          ? file.name.substring(44)
          : file.name;
      let i = this.form.qualification.findIndex((item) => {
        let object_name = /^device\//.test(item.object_name)
            ? item.object_name.substring(44)
            : item.object_name;
        return object_name === name;
      });
      return i == -1;
    },
    async selectedFile() {
      let dropzoneFile = document.querySelector(".dropzoneFile").files[0];
      if (!dropzoneFile) return;

      if (dropzoneFile.size > this.fileMaxSize) {
        this.$emit(
            "handleAlert",
            "danger",
            this.$t("page.files_upload.file_size_cannot_exceed_50M"),
            "ri-error-warning-line"
        );
        document.getElementById("dropzoneFile").value = "";
        return;
      }

      if (!this.checkFile(dropzoneFile)) {
        this.$emit(
            "handleAlert",
            "danger",
            this.$t("page.files_upload.same_name_file"),
            "ri-error-warning-line"
        );
        document.getElementById("dropzoneFile").value = "";
        return;
      }
      let suffix = dropzoneFile.name.substring(
          dropzoneFile.name.lastIndexOf(".")
      );
      if (/\.(png|jpeg|jpg)$/.test(suffix)) {
        let file = await imageCompress(dropzoneFile);
        this.uploadFileSign(file);
      } else {
        this.uploadFileSign(dropzoneFile);
      }
    },
    async drop(e) {
      let dropzoneFile = e.dataTransfer.files[0];
      if (!dropzoneFile) return;

      if (dropzoneFile.size > this.fileMaxSize) {
        this.$emit(
            "handleAlert",
            "danger",
            this.$t("page.files_upload.file_size_cannot_exceed_50M"),
            "ri-error-warning-line"
        );
        document.getElementById("dropzoneFile").value = "";
        return;
      }

      if (!this.checkFile(dropzoneFile)) {
        this.$emit(
            "handleAlert",
            "danger",
            this.$t("page.files_upload.same_name_file"),
            "ri-error-warning-line"
        );
        document.getElementById("dropzoneFile").value = "";
        return;
      }
      let suffix = dropzoneFile.name.substring(
          dropzoneFile.name.lastIndexOf(".")
      );
      if (/\.(png|jpeg|jpg)$/.test(suffix)) {
        let file = await imageCompress(dropzoneFile);
        this.uploadFileSign(file);
      } else {
        this.uploadFileSign(dropzoneFile);
      }
    },
    deleteFile(i) {
      Swal.fire(this.$t("base.delete_success"));
      this.showfiles.splice(i, 1);
      this.form.qualification.splice(i, 1);
    },
    uploadFileSign(file) {
      Swal.fire({
        title: this.$t("page.files_upload.uploading"),
        showConfirmButton: false,
      });
      Swal.showLoading();
      let filename = file.name;
      let objectName = `device/${uuidv4()}/${filename}`;
      let params = {
        object: objectName,
        method: "upload",
      };
      getUploadFileSign(params)
          .then((res) => {
            if (res && res.payload) {
              axios
                  .put(res.payload.signedUrl, file, {
                    headers: { "Content-Type": file.type },
                  })
                  .then(() => {
                    let params = {
                      object: objectName,
                    };
                    getUploadFileDetail(params).then((resDetail) => {
                      if (resDetail && resDetail.payload) {
                        let detail = resDetail.payload;
                        let info = {
                          url: detail.url,
                          etag: detail.etag,
                          size: detail.size,
                          content_type: detail.contentType,
                          object_name: detail.objectName,
                          last_modified: detail.lastModified,
                        };
                        // let suffix = info.object_name.substring(
                        //     info.object_name.lastIndexOf(".")
                        // );

                        document.getElementById("dropzoneFile").value = "";
                        postUpdateFile(info).then((post) => {
                          if (post && post.payload && post.payload.id) {
                            this.form.qualification.push(post.payload.id);
                            this.showfiles.push(post.payload.id);

                          }
                        });
                        Swal.close();
                        this.$emit(
                            "handleAlert",
                            "success",
                            this.$t("base.upload_success"),
                            "ri-check-double-line"
                        );
                      }
                    });
                  })
                  .catch(() => {
                    Swal.close();
                    this.$emit(
                        "handleAlert",
                        "danger",
                        this.$t("base.delete_failed_please_try_again"),
                        "ri-error-warning-line"
                    );
                    document.getElementById("dropzoneFile").value = "";
                  });
            }
          })
          .catch(() => {
            Swal.close();
            this.$emit(
                "handleAlert",
                "danger",
                this.$t("base.delete_failed_please_try_again"),
                "ri-error-warning-line"
            );
            document.getElementById("dropzoneFile").value = "";
          });
    },
    open() {
      this.showModal = true
      this.$nextTick(()=>{
        this.provinceChange(this.form.province_id)
        this.form.qualification.map(item=>{
          this.showfiles.push(item.id)
        })
      })

    },
    async save() {
      this.v$.form.$touch()
      const result = await this.v$.$validate()
      // if (!this.form.logo) {
      //   alertError('提示', '请上传logo！')
      //   return
      // }
      for (let i = 0; i < this.v$.form.email.$errors.length; i++) {
        if (this.v$.form.email.$errors[i].$message == 'Value is not a valid email address') {
          alertError(this.$t('base.prompt'), this.$t('page.wrongEmailFormat'))
          return
        }
      }
      if (!result) {
        alertError(this.$t('base.prompt'), this.$t('page.pleaseCompleteTheRequiredInformation'))
        return
      }

      if (this.roleType && (!this.form.service_area || this.form.service_area.length == 0)) {
        alertError(this.$t('base.prompt'), this.$t('请选择负责省份'))
        return
      }

      let params = this.roleType ? {

        id: this.form.id,
        username: this.form.username,
        role_id: this.form.role_id,
        first_name: this.form.first_name,
        last_name: this.form.last_name,
        tel: this.form.tel,
        email: this.form.email,
        tags: JSON.stringify(this.form.tags),
        qualification: this.showfiles,
        service_area: this.form.service_area
      } : {
        id: this.form.id,
        username: this.form.username,
        role_id: this.form.role_id,
        first_name: this.form.first_name,
        last_name: this.form.last_name,
        tel: this.form.tel,
        email: this.form.email,
      }
      console.log(params)

      patchUserAccount(params).then(() => {
        this.$message.success(this.$t('base.add_success'))
        this.$emit('refresh')
        this.showModal=!this.showModal
        this.getProvince()
      }).catch(err => {
        console.log(err)
        alertError(this.$t('base.prompt'), this.$t(err.message))
      })
    },
    getProvince(){
      let params = {
        page_size: 0
      }
      serviceAreaProvince(params).then(res => {
        this.provinceList = res.payload
        this.provinceList.map(v => {
          v.label = v.name
          v.value = v.id;
          // this.$refs.eTable.toggleRowSelection(v,false)
          // console.log(this.$refs.xTable.getSelectionRows())
          // this.toggleSelection([v])
          // this.deviceListCheckList=
        })
      })
    },
    toggleSelection(){
      this.provinceList.map(v => {
       this.form.province_id.map(p=>{
         if(v.id===p){
           this.$refs.eTable.toggleRowSelection(v,true)
           console.log(this.$refs.eTable.getSelectionRows())

         }
       })
      })

    },
    locationSelected(selected) {
      if (selected) {
        this.form.country = selected[0]
        this.form.province = selected[1]
        this.form.city = selected[2]
      } else {
        this.form.country = null
        this.form.province = null
        this.form.city = null
      }
    },
    hiddenHandle(){
      this.roleType = ""
      this.showfiles = []
      this.form = {
        username: "",
        role_id: "",
        first_name: "",
        last_name: "",
        tel: "",
        email: "",
        province_id: [],
        is_default: "",
        tags: [],
        qualification: [],
        service_area: []
      }
      this.v$.form.$reset()
    },
    handleSelectAll(selection){
      console.log(selection)
      this.form.province_id=[]
      selection.map(item=>{
        this.form.province_id.push(item.value)
      })
    },
    handleSelect(selection, row){
      this.form.province_id=[]
      if (row.children && row.children.length > 0) {
        row.children.map(item => {
          this.$refs.eTable.toggleRowSelection(item, false)
        })
      }
      selection = this.$refs.eTable.getSelectionRows()
      console.log(selection)
      selection.map(item=>{
        this.form.province_id.push(item.value)
      })
    },
  },
  components: {
    DropZone,
    SwiperTool,
    uploadAvatar,
    // datePickr,
    // LocationSelect,
  }
}
</script>
<template>
  <b-modal
      v-model="showModal"
      hide-footer
      :title="title"
      class="v-modal-custom"
      body-class="p-0"
      scrollable
      centered
      size="lg"
      @hidden="hiddenHandle"
  >
    <div class="modal-body border-top" style="max-height: 60vh;">
      <div class="logo-wraper d-flex justify-content-center mb-3">
        <upload-avatar v-model="form.logo" input-id="uploadLogo" filename-prefix="sc" return-type="url"></upload-avatar>
      </div>
      <div class="row">
        <div class="col-6">
            <div class="mb-3">
              <label class="form-label field-title" for="meta-keywords-input"><span class="text-danger">*</span>{{ $t('also.last name') }}</label>
              <input type="text" class="form-control" :class="v$.form.first_name.$errors.length ? 'is-invalid' : ''"  :placeholder="$t('also.last name')" v-model="form.first_name" @blur="v$.form.first_name.$touch()"/>
            </div>
          </div>
        <div class="col-6">
          <div class="mb-3">
            <label class="form-label field-title" for="meta-keywords-input"><span class="text-danger">*</span>{{ $t('also.first name') }}</label>
            <input type="text" class="form-control" :class="v$.form.last_name.$errors.length ? 'is-invalid' : ''"  :placeholder="$t('also.first name')" v-model="form.last_name" @blur="v$.form.last_name.$touch()"/>
          </div>
        </div>
        <div class="col-6">
          <div class="mb-3">
            <label class="form-label field-title" for="meta-keywords-input"><span class="text-danger">*</span>{{ $t('page.user.account') }}</label>
            <input type="text" class="form-control" disabled :class="v$.form.username.$errors.length ? 'is-invalid' : ''" :placeholder="$t('page.user.account')" v-model="form.username" @blur="v$.form.username.$touch()" required/>
          </div>
        </div>
        <div class="col-6">
          <div class="mb-3">
            <label class="form-label field-title" for="meta-keywords-input">{{$t('page.user.role')}}</label>
            <el-tree-select
                class="w-100"
                v-if="showModal"
                v-model="form.role_id"
                :data="roleList"
                :check-strictly="true"
                :filter-node-method="filterNodeMethod"
                :default-expand-all="true"
                :props="{children: 'sub', label: 'name'}"
                node-key="id"
                filterable
                @change="roleChange($event)"
            />
          </div>
        </div>
        <div class="col-6">
          <div class="mb-3">
            <label class="form-label field-title" for="meta-keywords-input"><span class="text-danger">*</span>{{$t('page.user.phone')}}</label>
            <input type="text" class="form-control" :class="v$.form.tel.$errors.length ? 'is-invalid' : ''" :placeholder="$t('page.user.phone')" v-model="form.tel" @blur="v$.form.tel.$touch()" required/>
          </div>
        </div>
        <div class="col-6">
          <div class="mb-3">
            <label class="form-label field-title" for="meta-keywords-input"><span class="text-danger">*</span>{{$t('page.user.email')}}</label>
            <input type="text" class="form-control"  :class="v$.form.email.$errors.length ? 'is-invalid' : ''" :placeholder="$t('page.user.email')" v-model="form.email" @blur="v$.form.email.$touch()" required/>
          </div>
        </div>
        <div v-if="roleType" class="col-6">
          <div class="mb-3">
            <label class="form-label field-title" for="meta-keywords-input"><span class="text-danger">*</span>{{ $t('page.auditing.province') }}</label>
            <el-popover placement="right" :width="400" trigger="click" @show="toggleSelection">
              <template #reference>
                <Multiselect
                    class="form-control"
                    :class="v$.form.province_id.$errors&&v$.form.province_id.$errors.length ? 'is-invalid' : ''"
                    mode="tags"
                    :can-clear="false"
                    :can-deselect="false"
                    v-model="form.province_id"
                    :close-on-select="true"
                    :searchable="true"
                    :create-option="false"
                    :placeholder="$t('page.auditing.province')"
                    :options="provinceList"
                    :disabled="true"
                    @change="provinceChange($event)"
                />
              </template>
                <el-table ref="eTable" :data="provinceList" @select-all="handleSelectAll" height="400"  @select="handleSelect">

                  <el-table-column fixed type="selection" width="55"/>
                  <el-table-column  property="label" :label="$t('page.auditing.province')" />
                  <el-table-column property="full_name" :label="$('默认联系人')" />
                </el-table>

            </el-popover>

          </div>
        </div>
        <div v-if="roleType" class="col-6">
          <div class="mb-3">
            <label class="form-label field-title" for="meta-keywords-input">{{ $t('page.user.label') }}</label>
            <Multiselect
                v-model="form.tags"
                mode="tags"
                :searchable="true"
                :caret="false"
                :create-tag="true"
                :show-options="false"
                :options="form.tags"
            />
          </div>
        </div>
        <div v-if="roleType == 'sale'" class="col-12">
          <div class="mb-3">
            <label class="form-label field-title" for="meta-keywords-input">{{ $t('默认接受人') }}</label>
             <div class="d-flex align-items-center w-100 overflow-auto">
               <a-checkbox
                   v-for="a in form.service_area"
                   :key="a.id"
                   style="display: flex;align-items: flex-end;"
                   v-model:checked="a.is_default"
                   :disabled="a.has_default"
               >
                 <span class="badge bg-success" style="line-height:22px">{{provinceText(a.province_id, provinceList)}}</span>
               </a-checkbox>
             </div>
          </div>
        </div>
        <div v-if="roleType" class="col-12">
          <div class="mb-3">
            <div class="w-100">
              <DropZone
                  @drop.prevent="drop"
                  @change="selectedFile"
                  :fileInfo="{
                    title: this.$t('资质证书上传') ,
                    accept: this.$t('page.files_upload.type'),
                    limit: '50M',
                  }"
                  :accept="'.ppt,.pptx,.pdf,.xls,.xlsx,.doc,.docx,.png,.jpeg,.jpg,.mp4,.mov,.stp,.glb'"
              />
              <h4
                  class="card-title mb-1 mt-3 flex-grow-1"
              >
                {{ this.$t("page.files_upload.uploaded_data") }}
              </h4>
              <div
                  class="border border-solid rounded p-3"
              >
                <div >
                  <div>
                    <div class="border-primary fs-14 material-title">
                      {{ this.$t("base.document") }}
                    </div>
                  </div>
                  <div class="product-img-slider sticky-side-div ps-5 pe-5">
                    <SwiperTool
                        :swiperInfo="{
                          type: 'document',
                          page: 'modelform',
                          spaceBetween: 10,
                          slidesPerView: 15,
                          actionsClass: [
                            { name: 'ri-eye-fill', action: 'view' },
                            { name: 'ri-download-2-fill', action: 'download' },
                            { name: 'ri-delete-bin-5-fill',action: 'delete' },
                          ],
                        }"
                        :list="form.qualification"
                        @deleteFile="deleteFile"
                    >
                    </SwiperTool>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer v-modal-footer" style="padding-right: 20px;padding-bottom: 20px;">
      <b-button type="button" variant="light" @click="showModal = false">{{this.$t('base.cancel')}}</b-button>
      <b-button type="button" variant="primary" @click="save">{{this.$t('base.done')}}</b-button>
    </div>
  </b-modal>
</template>
<style scoped>
.field-title {
  width: 300px;
}
.multiselect {
  padding: 0 0.9rem;
}
:deep(.multiselect-wrapper) {
  position: unset;
}

</style>
